import { useQueryClient } from 'react-query';
import { Button, Modal } from 'antd';
import { DataFeedConfig } from '@cbinsights/externalapiservice/externalapiservice';
import { DeleteOutlined } from '@ant-design/icons';
import { useDeleteDataFeedConfigMutation } from '../services/hooks';

export const DeleteDataFeedButton = ({
  feed,
  idTeam,
}: {
  feed: DataFeedConfig;
  idTeam: string;
}) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useDeleteDataFeedConfigMutation();
  const [modal, contextHolder] = Modal.useModal();

  const handleOk = async () => {
    try {
      await mutateAsync({ id_data_feed: feed.id_data_feed });
    } catch (e) {
      console.error('failed to delete data feed', e); // eslint-disable-line no-console
    }

    await queryClient.invalidateQueries({
      queryKey: ['ListDataFeedConfigResponse', idTeam],
    });
  };

  const confirmDelete = () => {
    modal.confirm({
      className: 'text-left',
      title: 'Delete Data Feed',
      content: `Are you sure you want to delete ${feed.data_feed_name} (${feed.id_data_feed})?`,
      okText: 'Delete',
      okButtonProps: { danger: true },
      onOk: handleOk,
      getContainer: false,
    });
  };

  return (
    <>
      {contextHolder}
      <Button type="text" key="delete" onClick={confirmDelete} danger>
        <DeleteOutlined /> Delete
      </Button>
    </>
  );
};
